const awsConfigLocal = {
  Auth: {
    userPoolId: 'us-east-1_rnoMi61mS',
    userPoolWebClientId: '6t5490qp1msnbd0fd0s4isurvs',
    region: 'us-east-1',
    URL: 'http://localhost:3000',
    oauth: {
      domain: 'screen-auth.truist.atd.enigma.com',
      scope: ['openid', 'email'],
      redirectSignIn: 'http://localhost:3000',
      redirectSignOut: 'http://localhost:3000',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'ScreenConsoleListApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleKeyApi',
        endpoint: 'https://jadacitpad.execute-api.us-east-1.amazonaws.com/screen/console/',
      },
      {
        name: 'ScreenListApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
    ],
  },
};

const awsConfigATD = {
  ...awsConfigLocal,
  Auth: {
    userPoolId: 'us-east-1_rnoMi61mS',
    userPoolWebClientId: '6t5490qp1msnbd0fd0s4isurvs',
    region: 'us-east-1',
    URL: 'https://truist.screen.atd.enigma.com',
    oauth: {
      domain: 'screen-auth.truist.atd.enigma.com',
      scope: ['openid', 'email'],
      redirectSignIn: 'https://truist.screen.atd.enigma.com',
      redirectSignOut: 'https://truist.screen.atd.enigma.com',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'ScreenConsoleListApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleKeyApi',
        endpoint: 'https://jadacitpad.execute-api.us-east-1.amazonaws.com/screen/console/',
      },
      {
        name: 'ScreenListApi',
        endpoint: 'https://api.truist.atd.enigma.com/screen/console/',
      },
    ],
  },
};

const awsConfigTPUat2 = {
  Auth: {
    userPoolId: 'us-east-1_454nUwVX6',
    userPoolWebClientId: '7s8r4sfph45gjicr9fktk06rcc',
    region: 'us-east-1',
    URL: 'https://screen.uat2.truist.enigma.com',
    oauth: {
      domain: 'screen-auth.truist.enigma.com',
      scope: ['openid', 'email'],
      redirectSignIn: 'https://screen.uat2.truist.enigma.com',
      redirectSignOut: 'https://screen.uat2.truist.enigma.com',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'ScreenConsoleListApi',
        endpoint: 'https://api.uat2.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleApi',
        endpoint: 'https://api.uat2.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleKeyApi',
        endpoint: 'https://n7tk7ca5a6.execute-api.us-east-1.amazonaws.com/screen/console/',
      },
      {
        name: 'ScreenListApi',
        endpoint: 'https://api.uat2.truist.enigma.com/screen/console/',
      },
    ],
  },
};

const awsConfigTPUat1 = {
  Auth: {
    userPoolId: 'us-east-1_454nUwVX6',
    userPoolWebClientId: '1glrhj8og9opvdb35a1c5er8bq',
    region: 'us-east-1',
    URL: 'https://screen.uat1.truist.enigma.com',
    oauth: {
      domain: 'screen-auth.truist.enigma.com',
      scope: ['openid', 'email'],
      redirectSignIn: 'https://screen.uat1.truist.enigma.com',
      redirectSignOut: 'https://screen.uat1.truist.enigma.com',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'ScreenConsoleListApi',
        endpoint: 'https://api.uat1.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleApi',
        endpoint: 'https://api.uat1.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleKeyApi',
        endpoint: 'https://0wlg8adyk4.execute-api.us-east-1.amazonaws.com/screen/console/',
      },
      {
        name: 'ScreenListApi',
        endpoint: 'https://api.uat1.truist.enigma.com/screen/console/',
      },
    ],
  },
};

const awsConfigTPProd = {
  Auth: {
    userPoolId: 'us-east-1_454nUwVX6', // screen-users-truist
    userPoolWebClientId: '1nk9ca51mfm9u4ockelb2hcl0d', // screen-truist-console-client-prod
    region: 'us-east-1',
    URL: 'https://screen.prod.truist.enigma.com',
    oauth: {
      domain: 'screen-auth.truist.enigma.com',
      scope: ['openid', 'email'],
      redirectSignIn: 'https://screen.prod.truist.enigma.com',
      redirectSignOut: 'https://screen.prod.truist.enigma.com',
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'ScreenConsoleListApi',
        endpoint: 'https://api.prod.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleApi',
        endpoint: 'https://api.prod.truist.enigma.com/screen/console/',
      },
      {
        name: 'ScreenConsoleKeyApi',
        endpoint: 'https://w7xsbansx6.execute-api.us-east-1.amazonaws.com/screen/console/',
      },
      {
        name: 'ScreenListApi',
        endpoint: 'https://api.prod.truist.enigma.com/screen/console/',
      },
    ],
  },
};

const getAws = () => {
  const env = process.env.REACT_APP_ENV;
  switch (env) {
    case 'atd':
        return awsConfigATD;
    case 'tp-uat2':
      return awsConfigTPUat2;
    case 'tp-uat1':
      return awsConfigTPUat1;  
    case 'tp-prod':
      return awsConfigTPProd;
    default:
      return awsConfigLocal;
  }
};

const awsConfig = getAws();

export default awsConfig;
